module.exports = __webpack_public_path__ + "static/yulia_3-8ed42bcdac0fd68ec0cf962d28a1a712.jpg";